import * as Schema from "effect/Schema";
import * as Rpc from "effect/unstable/rpc/Rpc";
import * as RpcGroup from "effect/unstable/rpc/RpcGroup";
import { EnvironmentAuthorizationError } from "./auth.ts";

const ModelId = Schema.String.check(Schema.isPattern(/^[a-zA-Z0-9][a-zA-Z0-9_-]{0,95}$/));
const LocalPath = Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(4096));
export const LocalModelCommand = Schema.Union([
  Schema.Struct({
    action: Schema.Literal("import"),
    path: LocalPath,
    projectorPath: Schema.optionalKey(LocalPath),
  }),
  Schema.Struct({ action: Schema.Literals(["load", "trash", "restore"]), id: ModelId }),
  Schema.Struct({ action: Schema.Literal("unload") }),
  Schema.Struct({
    action: Schema.Literals(["speech.prepare", "speech.cancel", "speech.load"]),
    engine: Schema.Literals(["stt", "tts"]),
  }),
  Schema.Struct({ action: Schema.Literal("speech.unload") }),
]);
export type LocalModelCommand = typeof LocalModelCommand.Type;
export const SpeechModelSnapshot = Schema.Struct({
  engine: Schema.Literals(["stt", "tts"]),
  model: Schema.String,
  installed: Schema.Boolean,
  loaded: Schema.Boolean,
  activeOperations: Schema.Number,
  phase: Schema.Literals(["idle", "verifying", "downloading", "extracting"]),
  downloadedBytes: Schema.Number,
  error: Schema.NullOr(Schema.String),
});
export type SpeechModelSnapshot = typeof SpeechModelSnapshot.Type;
export const LocalModelsSnapshot = Schema.Struct({
  speechModels: Schema.optionalKey(Schema.Array(SpeechModelSnapshot)),
  engineAvailable: Schema.Boolean,
  models: Schema.Array(
    Schema.Struct({
      id: ModelId,
      name: Schema.String,
      bytes: Schema.Number,
      trashed: Schema.Boolean,
      activeLeases: Schema.Number,
      contextTokens: Schema.optionalKey(Schema.Number),
    }),
  ),
  loadedModelId: Schema.NullOr(Schema.String),
});
export type LocalModelsSnapshot = typeof LocalModelsSnapshot.Type;
export class LocalModelError extends Schema.TaggedErrorClass<LocalModelError>()("LocalModelError", {
  message: Schema.String,
}) {}
export const LOCAL_MODELS_RPC = {
  list: "localModels.list",
  command: "localModels.command",
} as const;
export const LocalModelsRpcGroup = RpcGroup.make(
  Rpc.make(LOCAL_MODELS_RPC.list, {
    payload: Schema.Struct({}),
    success: LocalModelsSnapshot,
    error: Schema.Union([LocalModelError, EnvironmentAuthorizationError]),
  }),
  Rpc.make(LOCAL_MODELS_RPC.command, {
    payload: LocalModelCommand,
    success: LocalModelsSnapshot,
    error: Schema.Union([LocalModelError, EnvironmentAuthorizationError]),
  }),
);
